import { FC, useContext } from "react";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";
import { BaseContext } from "@app/network-portfolio-management/contexts/BaseContext";

interface MetricWidgetBaseProps {
  title: string;
  isLoading?: boolean;
  error?: boolean;
  children?: React.ReactNode;
}

export const MetricWidgetBase: FC<MetricWidgetBaseProps> = ({ title, children, isLoading = false, error = false }) => {
  const { loading: baseLoading, resourcesError } = useContext(BaseContext);
  const effectiveLoading = baseLoading || isLoading;
  const effectiveError = !!resourcesError || error;

  const body = () => {
    if (effectiveError) {
      return <p>There was a problem loading your data. Please try again.</p>;
    }
    if (effectiveLoading) {
      return (
        <div className="skeleton shimmer">
          <div className="bone" />
        </div>
      );
    }
    return children;
  };

  return (
    <QESWidget className="network-portfolio-management-key-metrics-widget">
      <QESWidgetHeader>
        <QESWidgetTitle className="title">
          {title.toUpperCase()}
        </QESWidgetTitle>
      </QESWidgetHeader>
      <QESWidgetContent>
        {body()}
      </QESWidgetContent>
    </QESWidget>
  );
};
